<template>
  <div id="home">
    <banner />
    <!-- 2025年2月27日 15:40:14  学院图标 暂不显示 -->
    <college-icon v-if="false" />
    <!-- 添加悬浮窗组件 -->
    <!-- 2025年4月7日 09:37:48 关闭悬浮窗组件 -->
    <floating-window />

    <main-content />
  </div>
</template>

<script>
  import Banner from "@/components/banner.vue"
  import CollegeIcon from "@/components/collegeIcon.vue"
  import MainContent from "@/components/mainContent.vue"
  // 引入悬浮窗组件
  import FloatingWindow from "@/components/floatingWindow.vue"

  export default {
    components: {
      Banner,
      CollegeIcon,
      MainContent,
      // 添加悬浮窗组件
      FloatingWindow
    },
    data() {
      return {}
    },
    mounted() {},
    methods: {
      // 添加悬浮窗点击事件处理方法
      handleFloatingWindowClick() {
        this.$router.push("/level-up") // 跳转到练级页面
      }
    }
  }
</script>

<style scoped>
  #home {
  }
  @media (max-width: 1440px) {
    #home {
      /* min-width: 1560px; */
      padding: 0 15px;
    }
  }

  @media (max-width: 768px) {
    .floating-window-icon {
      width: 100%;
      margin: 10px -10px 10px 0;
      box-shadow: 0 0px 0px 0px rgba(0, 0, 0, 0.2) !important;
    }
  }

  .floating-window-icon {
    border: 4px solid #ccc;
    border-radius: 8px;

    box-shadow: 0 0px 4px 4px rgba(0, 0, 0, 0.2);
  }
</style>
